import React from 'react';
import styled from 'styled-components';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import Col from 'components/ui/Col';
import Form from 'components/ui/Form';
import DatePicker from 'components/ui/DatePicker';
import { media } from 'helpers/MediaHelper';
import { addDayToCurrentDay } from 'helpers/DateHelper';

import moment from 'moment';

const FullWidthDatePicker = styled(DatePicker)`
  width: 100%;
`;

const StyledMt = styled(Col)`
  ${media.mobile`
    margin-top: 1rem;
  `};
`;

const StartDateInput = ({ values, errors, touched, setFieldValue }) => {
  const handleChange = value => {
    setFieldValue('start_date', value);
  };

  return (
    <StyledMt sm={12}>
      <Form.Item
        label={getTranslatedString('landlordPortal.events.startDateLabel')}
        validateStatus={touched.start_date && errors.start_date ? 'error' : null}
        help={touched.start_date && errors.start_date}
      >
        <FullWidthDatePicker
          size="large"
          value={values.start_date}
          placeholder={getTranslatedString('landlordPortal.events.startDatePlaceholder')}
          defaultPickerValue={moment().locale(getCurrentLocale())}
          showToday={false}
          disabledDate={date => !date || date.isBefore(new Date().setHours(0, 0, 0, 0))}
          minDate={addDayToCurrentDay()}
          mobileMode="datetime"
          showTime={{ format: 'h:mm a' }}
          dateFormat="YYYY-MM-DD hh:mm a"
          onChange={handleChange}
        />
      </Form.Item>
    </StyledMt>
  );
};

export default StartDateInput;
